<template>
  <div>
    <el-card class="">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('mappingDomain.queryCondition') }}</span>
      </div>
      <div class="card-body">
        <el-form :inline="true" :model="mappingDomainManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="mappingDomainManageInfo.conditions.domain"
              :placeholder="$t('mappingDomain.selectDomain')" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="mappingDomainManageInfo.conditions.seq" :placeholder="$t('mappingDomain.selectSeq')"
              clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryMappingDomainMethod">
              {{ $t('mappingDomain.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('mappingDomain.configItems') }}</span>
        <el-button type="primary" size="small" style="float: right" @click="_openAddMappingDomainModal">
          {{ $t('mappingDomain.add') }}
        </el-button>
      </div>
      <div class="">
        <el-table :data="mappingDomainManageInfo.mappingDomains" border style="width: 100%">
          <el-table-column prop="domainName" :label="$t('mappingDomain.name')" align="center" />
          <el-table-column prop="domain" :label="$t('mappingDomain.configItem')" align="center" />
          <el-table-column prop="seq" :label="$t('mappingDomain.seq')" align="center" />
          <el-table-column :label="$t('mappingDomain.operation')" align="center" width="200">
            <template #default="scope">
              <el-button size="mini" @click="_openEditMappingDomainModel(scope.row)">
                {{ $t('mappingDomain.edit') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteMappingDomainModel(scope.row)">
                {{ $t('mappingDomain.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination :current-page="currentPage" :page-size="pageSize" :total="total"
          layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" />
      </div>
    </el-card>

    <add-mapping-domain ref="addMappingDomain" @success="queryMappingDomain" />
    <edit-mapping-domain ref="editMappingDomain" @success="queryMappingDomain" />
    <delete-mapping-domain ref="deleteMappingDomain" @success="queryMappingDomain" />
  </div>
</template>

<script>
import { listMappingDomain } from '@/api/dev/mappingDomainApi'
import AddMappingDomain from '@/components/dev/addMappingDomain/addMappingDomain.vue'
import EditMappingDomain from '@/components/dev/editMappingDomain/editMappingDomain.vue'
import DeleteMappingDomain from '@/components/dev/deleteMappingDomain/deleteMappingDomain.vue'

export default {
  name: 'MappingDomainManage',
  components: {
    AddMappingDomain,
    EditMappingDomain,
    DeleteMappingDomain
  },
  data() {
    return {
      mappingDomainManageInfo: {
        mappingDomains: [],
        conditions: {
          domain: '',
          seq: ''
        }
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this._listMappingDomains(this.currentPage, this.pageSize)
  },
  methods: {
    queryMappingDomain() {
      this._listMappingDomains(1, this.pageSize)
    },
    async _listMappingDomains(page, rows) {
      try {
        const params = {
          ...this.mappingDomainManageInfo.conditions,
          page,
          row:rows
        }
        const res = await listMappingDomain(params)
        this.mappingDomainManageInfo.mappingDomains = res.data
        this.total = res.records
      } catch (error) {
        console.error(error)
      }
    },
    _openAddMappingDomainModal() {
      this.$refs.addMappingDomain.open()
    },
    _openEditMappingDomainModel(row) {
      this.$refs.editMappingDomain.open(row)
    },
    _openDeleteMappingDomainModel(row) {
      this.$refs.deleteMappingDomain.open(row)
    },
    _queryMappingDomainMethod() {
      this.currentPage = 1
      this._listMappingDomains(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listMappingDomains(this.currentPage, this.pageSize)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listMappingDomains(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>